import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';

export const VariantGridWrapper = styled.div`
  display: flex;
  gap: ${layout.measurements.spacing050};
  width: 100%;
  flex-wrap: wrap;

  ${media.mediumUp`
    width: max-content;
    max-width: 340px;
    margin: 0 ${layout.measurements.spacing050};
  `}
`;

type VariantGridCellProps = {
  $order: number;
};

export const VariantGridCell = styled.div<VariantGridCellProps>`
  display: flex;
  padding: 1px;
  order: ${props => props.$order};
`;

type ColorProps = {
  $hex: string;
};

export const StyledColorDot = styled.span<ColorProps>(
  props => css`
    width: ${layout.measurements.spacing100};
    min-width: ${layout.measurements.spacing100};
    height: ${layout.measurements.spacing100};
    min-height: ${layout.measurements.spacing100};
    border-radius: ${layout.measurements.spacing050};
    background: ${props.$hex};

    ${props.$hex === '#FFFFFF' &&
    css`
      border: 1px solid ${props.theme.colors.base300};
    `};
  `
);
